module.exports = __webpack_public_path__ + "static/img/200220.e310d1d6.png";